import { createI18n } from 'vue-i18n'

const messages = {
  ar: {
    nav: {
      home: 'الصفحة الرئيسية',
      courses: 'الكورسات',
      teachers: 'الاساتذة',
      unsubscribe: 'إلغاء الاشتراك',
      subscribe: 'إشتراك',
      login: 'دخول',
      cancelSubscription: 'الغاء الاشتراك',
      search: 'بحث'
    },
    home: {
      mayLike: 'محاضرات قد تعجبك',
      allCourses: 'كل الكورسات'
    },
    courses: {
      all: 'كل الكورسات'
    },
    teachers: {
      title: 'الاساتذة',
      allLecturesBy: 'كل محاضرات الاستاذ',
      allVideos: 'كل الفيديوهات',
      prefix: 'أ /'
    },
    series: {
      play: 'تشغيل',
      allVideos: 'كل الفيديوهات',
      prefix: 'أ /'
    },
    search: {
      resultsFor: 'نتائج البحث عن'
    },
    login: {
      title: 'تسجيل دخول',
      phone: 'رقم الهاتف',
      submitting: 'جاري تسجيل الدخول',
      submit: 'تسجيل الدخول',
      notSudanese: 'رقم الهاتف ليس سوداني',
      mustBe10: 'رقم الهاتف يجب ان يتكون من 10 ارقام',
      pleaseEnter: 'الرجاء ادخال رقم الهاتف',
      loggedIn: 'تم تسجيل الدخول استمتع بتجربة فريدة من منصة كورساتي',
      loggedInShort: 'تم تسجيل الدخول',
      alreadySubNotRenewed: 'عفوا انت مشترك مسبقا ولم يتم تجديد اشتراكك',
      notSubscribed: 'عفوا انت لست مشترك في منصة كورساتي'
    },
    unsubscribe: {
      title: 'تأكيد الغاء الاشتراك',
      submitting: 'جاري الغاء اشتراكك',
      submit: 'الغاء الاشتراك',
      notSubscribed: 'انت لست مشترك في منصة كورساتي',
      done: 'تم الغاء اشتراكك من منصة كورساتي'
    },
    toast: {
      welcome: 'مرحبا بك معنا',
      redirecting: 'سوف يتم تحويلك الي المحتوي',
      notSubscribedCourseatk: 'عفوا انت لست مشترك في كورساتي'
    },
    notFound: {
      lost: 'يبدو أنك تائه',
      unavailable: 'الصفحة التي تبحث عنها غير متوفرة!',
      backHome: 'الرجوع الي الصفحة الرئيسية'
    },
    langToggle: 'EN'
  },
  en: {
    nav: {
      home: 'Home',
      courses: 'Courses',
      teachers: 'Instructors',
      unsubscribe: 'Unsubscribe',
      subscribe: 'Subscribe',
      login: 'Login',
      cancelSubscription: 'Cancel Subscription',
      search: 'Search'
    },
    home: {
      mayLike: 'Lectures You May Like',
      allCourses: 'All Courses'
    },
    courses: {
      all: 'All Courses'
    },
    teachers: {
      title: 'Instructors',
      allLecturesBy: 'All lectures by',
      allVideos: 'All Videos',
      prefix: 'Prof.'
    },
    series: {
      play: 'Play',
      allVideos: 'All Videos',
      prefix: 'Prof.'
    },
    search: {
      resultsFor: 'Search results for'
    },
    login: {
      title: 'Login',
      phone: 'Phone Number',
      submitting: 'Logging in',
      submit: 'Login',
      notSudanese: 'Phone number is not Sudanese',
      mustBe10: 'Phone number must be 10 digits',
      pleaseEnter: 'Please enter phone number',
      loggedIn: 'Logged in. Enjoy your Courseatk experience',
      loggedInShort: 'Logged in',
      alreadySubNotRenewed: 'You are already subscribed but your subscription has not been renewed',
      notSubscribed: 'You are not subscribed to Courseatk'
    },
    unsubscribe: {
      title: 'Confirm Unsubscribe',
      submitting: 'Cancelling your subscription',
      submit: 'Unsubscribe',
      notSubscribed: 'You are not subscribed to Courseatk',
      done: 'Your Courseatk subscription has been cancelled'
    },
    toast: {
      welcome: 'Welcome',
      redirecting: 'Redirecting you to the content',
      notSubscribedCourseatk: 'You are not subscribed to Courseatk'
    },
    notFound: {
      lost: 'You appear to be lost',
      unavailable: 'The page you are looking for is not available!',
      backHome: 'Back to Home'
    },
    langToggle: 'ع'
  }
}

const savedLocale = (typeof localStorage !== 'undefined' && localStorage.getItem('locale')) || 'ar'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'ar',
  messages
})

export function setLocale(loc) {
  i18n.global.locale.value = loc
  if (typeof localStorage !== 'undefined') localStorage.setItem('locale', loc)
  applyDir(loc)
}

export function applyDir(loc) {
  const dir = loc === 'en' ? 'ltr' : 'rtl'
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('dir', dir)
    document.documentElement.setAttribute('lang', loc)
  }
}

export function toggleLocale() {
  const next = i18n.global.locale.value === 'ar' ? 'en' : 'ar'
  setLocale(next)
}

export function localized(obj, field) {
  if (!obj) return ''
  const loc = i18n.global.locale.value
  const enVal = obj[field + '_en']
  // Fall back to the unsuffixed field (e.g. cp_name) when there's no *_ar column.
  const arVal = (obj[field + '_ar'] !== undefined && obj[field + '_ar'] !== null)
    ? obj[field + '_ar']
    : obj[field]
  if (loc === 'en') {
    if (enVal && String(enVal).trim() !== '' && enVal !== arVal) return enVal
    return arVal || ''
  }
  return arVal || enVal || ''
}

applyDir(savedLocale)

export default i18n
